import { createRouter, createWebHistory } from 'vue-router'

const routeInfos = [
    {
        path: '/login/:id',
        name: 'login',
        component: () => import(/* webpackChunkName: 'about' */ './views/LoginView.vue'),
        meta: { guest: true },
    },
    {
        path: '/register/:id',
        name: 'register',
        component: () => import(/* webpackChunkName: 'about' */ './views/RegisterView.vue'),
        meta: { guest: true },
    },
    {
        path: '/verification-code/:id/:email',
        name: 'verification-code',
        component: () => import(/* webpackChunkName: 'about' */ './views/LoginVerificationView.vue'),
        meta: { guest: true },
    },
    {
        path: '/checkout/:id',
        name: 'booking-checkout',
        component: () => import(/* webpackChunkName: 'about' */ './views/BookingCheckoutView.vue'),
        meta: { requiresAuth: true },
    }, 
    {
        path: '/booking-history/:id',
        name: 'booking-history',
        component: () => import(/* webpackChunkName: 'about' */ './views/BookingHistoryView.vue'),
        meta: { requiresAuth: true },
    }, 
    {
        path: '/:id',
        name: 'booking',
        component: () => import(/* webpackChunkName: 'about' */ './views/BookingView.vue'),
        meta: { guest: true },
    },    
]

const router = createRouter({
    history : createWebHistory('#/'),
    routes : routeInfos
})

/*router.beforeEach(async (to, from, next) => {
    if(to.matched.some(record => record.meta.requiresAuth)) {
        const isAuthenticated = await cognito.isAuthenticated()
        if (isAuthenticated) {
            next()
            return
        }
        next('/login')
    } else {
        next()
    }
})

router.beforeEach(async (to, from, next) => {
    if (to.matched.some((record) => record.meta.guest)) {
        const isAuthenticated = await cognito.isAuthenticated()
        if (isAuthenticated) {
            next('/select-cco')
            return
        }
        next()
    } else {
        next()
    }
})*/

export default router;
